module.exports = __webpack_public_path__ + "static/media/image2.1981f785.jpeg";